import { sortObjectArray } from "../util.js";
import { ModalTiteledWindow } from "./modalWindow.js";

export class ModalShowDayAbsenceDetails extends ModalTiteledWindow {

   constructor(app, pupil, absences) {
      super();
      this.app = app;
      this.addClass('modal-show-absence-details');
      this.setTitle(`Fehltage/Fehlstunden: ${pupil.lastName}, ${pupil.firstName}`);
      this.setBody(`
         <div class="select">&nbsp;<span class="help icon-info" selector=".modal-day-absence-details" style="position: absolute; right: 0.5rem;"></span></div>
         <div class="absences"></div>
      `);

      this.setupHelp(this.app);

      if (absences.length === 0) {
         this.panel.querySelector('.absences').innerHTML = "Es liegen bisher keine Fehltage vor.";
      }
      else {
         sortObjectArray(absences, ['<.date']);

         let html = `
         <table class="bl-2 br-2 bt-2 bb-2">
         <thead>
            <tr><th>Datum</th><th>Faktor</th><th>entsch.</th><th>Bemerkung</th></tr>
         </thead>
         <tbody>`;

         for (let item of absences) {
            html += `<tr data-absence-id="${item.id}" data-justified="${item.justified ? 'true': 'false'}"><td>${Date.fromString(item.date).toGermanDate(true)}</td><td>${Math.round(item.factor * 1000) / 1000}</td><td class="justified ta-center">${item.justified ? '<span class="color-green">✔</span>' : '<span class="color-red">✖</span>'}</td><td>${item.note}</td></tr>`
         }

         html += '</tbody></table>';
         this.panel.querySelector('.absences').innerHTML = html;

         this.panel.querySelectorAll('.absences table td.justified').forEach(el => el.onclick = (event) => {
            let elTr = event.target.closest('tr');
            this.app.dm.sinRequest({
               action:     'day-absence-set-justified',
               id:         elTr.dataset.absenceId,
               justified:  elTr.dataset.justified !== "true"
            }).then((response) => {
               if (response.data && response.data.length > 0) {
                  this.panel.querySelectorAll(`.absences table tr[data-absence-id="${response.data[0].id}"]`).forEach(elTr => {
                     elTr.querySelector('td.justified').innerHTML = response.data[0].justified ? '<span class="color-green">✔</span>' : '<span class="color-red">✖</span>';
                     elTr.dataset.justified = response.data[0].justified ? 'true' : 'false';
                  });
                  this.app.classReg.redrawBuffer();
               }
            }).catch(error => this.app.handleError(error));

         });

      }

      setTimeout(() => this.show(), 1);

   }

}
